const truncateWords = (text, maxWords) => {
  let words = text.trim().split(/\s+/);
  if (words.length <= maxWords) return text;
  return words.slice(0, maxWords).join(' ') + ' ...';
};
export default truncateWords;
